import React from 'react';
import {
  Link,
  Outlet,
} from '@tanstack/react-router';

const Account: React.FC = () => {
  return (
    <div className="container account-container">
      <div className="wa-flank wa-flank:start wa-gap-0 wa-align-items-start" style={{ '--flank-size': '220px' } as React.CSSProperties}>
        <div className="wa-stack account-sidebar wa-gap-0 inner wa-align-items-start">
          <div className="page-eyebrow">
            My Account
          </div>
          <nav className="wa-stack wa-gap-0">
            <Link to="/account">My profile</Link>
            <Link to="/account/password">Change password</Link>
          </nav>
        </div>
        <div className="account-main wa-stack wa-gap-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Account;
